import { useEffect } from 'react';
import bootstrap from "../config/bootstrap";
import { BASE_URL } from "../config/config";

const init = bootstrap;

const Authenticate = () => {
    useEffect(() => {
        const { spaceIOService } = init();
        
        const initializeSpaceIoService = async () => {
            if (!spaceIOService?.initialized) {
                const response = await spaceIOService.init();
                spaceIOService.initialized = true;

                if (response === 'Done') {
                    window.location.href = `${BASE_URL}/deviceDebug`;
                }
            }
        };

        initializeSpaceIoService();
    }, []);

    return null;
};

export default Authenticate;
